<div class="dialog-title" mat-dialog-title>
    <cerrix-title
        style="flex: 1"
        size="large"
        [editable]="false"
        [value]="dialogTitle"
    ></cerrix-title>
    <button [attr.data-uiid]="'hyperlink-edit-close-top'" mat-icon-button mat-dialog-close>
        <mat-icon>close</mat-icon>
    </button>
</div>

<mat-dialog-content class="dialog-content">
    <ng-container *ngTemplateOutlet="hyperlinkFormTemplate"></ng-container>
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
    <cerrix-button [dataUiid]="'hyperlink-edit-close'" color="accent" mat-dialog-close
        >Close</cerrix-button
    >

    @if (dialogData.openReason !== "View") {
        <cerrix-button
            [dataUiid]="'hyperlink-edit-apply'"
            color="success"
            [disabled]="
                dialogData.canAddHyperlink === false ||
                dialogData.canEditHyperlink === false ||
                hyperlinkForm.invalid
            "
            (click)="onApplyChanges()"
            >{{ btnLabel }}</cerrix-button
        >
    }
</mat-dialog-actions>

<ng-template #hyperlinkFormTemplate>
    <div [formGroup]="hyperlinkForm" class="edit-hyperlink-container">
        <div class="wrapper">
            <cerrix-field-wrapper
                class="hyperlink-name"
                label="Name"
                type="primary"
                [required]="true"
            >
                <cerrix-input
                    formControlName="name"
                    [dataUiid]="'hyperlink-edit-name'"
                    [placeholder]="'Enter hyperlink name'"
                ></cerrix-input>
            </cerrix-field-wrapper>

            <cerrix-field-wrapper class="hyperlink-type" label="Hyperlink type" type="primary">
                <cerrix-select
                    formControlName="hyperlinkTypeId"
                    [dataUiid]="'hyperlink-edit-hyperlinktypeid'"
                    [options]="dialogData.hyperlinkTypes"
                ></cerrix-select>
            </cerrix-field-wrapper>
        </div>
        <cerrix-field-wrapper
            class="hyperlink-url"
            label="Hyperlink"
            type="primary"
            [required]="true"
        >
            <cerrix-input
                formControlName="hyperlink"
                [placeholder]="'Enter hyperlink URL'"
                [dataUiid]="'hyperlink-edit-hyperlink'"
            ></cerrix-input>
            @if (
                hyperlinkForm?.controls?.hyperlink?.touched &&
                hyperlinkForm?.controls?.hyperlink?.errors
            ) {
                <div class="error"></div>
            }
        </cerrix-field-wrapper>

        <cerrix-field-wrapper label="Description" type="primary">
            <cerrix-textarea
                formControlName="description"
                [dataUiid]="'hyperlink-edit-description'"
                [textareaAutosize]="true"
                [autosizeMinRows]="7"
            ></cerrix-textarea>
        </cerrix-field-wrapper>
    </div>
</ng-template>
